import React from "react";
import PropTypes from "prop-types";
import config from "../../res/config.json";
import { cssStyles } from "./pdfTransferAgreementStyles";
import { formatNumber, truncateText } from "../../logic/GeneralFunctions";

const emptyLabel = " ";

export default class CreateTransferAgreement extends React.Component {
  static propTypes = {
    formInformation: PropTypes.object,
    productsValues: PropTypes.object,
    customerInformation: PropTypes.object,
    labels: PropTypes.object,
    accessories: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    params: PropTypes.object,
    switchFormState: PropTypes.func,
    products: PropTypes.array,
  };

  state = { headerImgSrc: "" };

  get lang() {
    return this.props.params.lang.toLowerCase();
  }

  splitPNCNumAndName(item) {
    const regex = /^(\d+)\s*(.*)/;
    const match = item.match(regex);
    if (match) {
      return { id: match[1], name: match[2].trim() };
    } else {
      return { id: null, name: item.trim() };
    }
  }

  longTermSection() {
    if (this.lang === "fr") {
      return (
        <p style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <span
            style={{
              display: "inline-block",
              width: "15px",
              height: "15px",
              border: "1px solid black",
            }}
          />
          {this.props.labels.long_term}
        </p>
      );
    } else if (this.lang === "de") {
      return (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3.5px",
              marginTop: "11px",
              marginBottom: "5.5px",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "8.2px",
                height: "7.5px",
                border: "5px solid black",
                boxSizing: "border-box",
              }}
            />
            <span style={{ fontSize: "9px" }}>Mietvertrag</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "3.5px" }}>
            <span
              style={{
                display: "inline-block",
                width: "10px",
                height: "10px",
                border: "1px solid black",
                boxSizing: "border-box",
              }}
            />
            <span style={{ fontSize: "9px" }}>Mietkaufvertrag</span>
          </div>
        </>
      );
    } else if (this.lang === "uk") {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "3.5px",
            marginTop: "5px",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              border: "1px solid black",
              boxSizing: "border-box",
            }}
          />
          <span style={{ fontSize: "9px" }}>Operational</span>
        </div>
      );
    }
  }

  generateUKProductRow(key, objektNr) {
    const { productsValues, formInformation, params } = this.props;
    const product = this.splitPNCNumAndName(productsValues[key].name || "");

    return (
      <>
        <tr className="contract-agreement-table-header">
          <th colSpan="6" className="contract-small-margin-top">
            {objektNr ? `EQUIPMENT #${objektNr}` : "EQUIPMENT"}
          </th>
        </tr>
        <tr>
          <td className="contract-td uk-eq-col uk-w-26">
            <p className="uk-eq-label">Type of Equipment</p>
          </td>
          <td className="contract-td uk-eq-col uk-w-13">
            <p className="uk-eq-label">Serial number</p>
          </td>
          <td className="contract-td uk-eq-col uk-w-13">
            <p className="uk-eq-label">Type of leasing</p>
          </td>
          <td className="contract-td uk-eq-col uk-w-18">
            <p className="uk-eq-label">Purchase price in GBP (excl. VAT)</p>
          </td>
          <td className="contract-td uk-eq-col uk-w-18">
            <p className="uk-eq-label">
              Residual value in GBP (excl. VAT) at end of Hire Period
            </p>
          </td>
          <td className="contract-td uk-eq-col uk-w-12">
            <p className="uk-eq-label">Duration of Hire Period (months)</p>
          </td>
        </tr>
        <tr>
          <td className="contract-td uk-w-26">
            <p>{truncateText(product.name, 30)}</p>
          </td>
          <td className="contract-td uk-w-13">
            <p>
              {productsValues[key].serial.length > 0
                ? productsValues[key].serial[0]
                : ""}
            </p>
          </td>
          <td className="contract-td uk-w-13">{this.longTermSection()}</td>
          <td className="contract-td uk-w-18">
            <p className="uk-eq-currency">
              <span>£</span>
              <span>
                {formatNumber(
                  productsValues[key].purchasePrice +
                    productsValues[key].installation,
                  this.lang,
                )}
              </span>
            </p>
          </td>
          <td className="contract-td uk-w-18">
            <p className="uk-eq-currency">
              <span>£</span>
              <span>
                {formatNumber(productsValues[key].residualPrice, this.lang)}
              </span>
            </p>
          </td>
          <td className="contract-td uk-w-12">
            <p>{formInformation.contractLength}</p>
          </td>
        </tr>
      </>
    );
  }

  generateHirerDetails() {
    const { labels } = this.props;
    const {
      customerFirstName,
      customerLastName,
      dateOfBirth,
      customerStreet,
      customerHouseNumber,
      customerZipCode,
      customerCity,
      customerEmail,
    } = this.props.customerInformation;
    const customerName = customerFirstName + " " + customerLastName;
    const customerAddress = `${customerStreet} ${customerHouseNumber} ${customerZipCode} ${customerCity}`;
    const dateOfBirthFormatted = dateOfBirth
      ? new Date(dateOfBirth).toLocaleDateString("en-GB")
      : "";

    return (
      <div className="margin-top-min">
        <table className="contract-table">
          <tbody>
            <tr className="contract-agreement-table-header">
              <th colSpan="4" className="contract-small-margin-top">
                HIRER DETAILS
              </th>
            </tr>
            <tr>
              <td colSpan="2" className="contract-td contract-half-space">
                <p className="contract-helper-text">
                  {labels.label_customer_name}
                </p>
                <p>{customerName}</p>
              </td>
              <td
                colSpan="2"
                className="contract-td contract-half-space contract-border-thick"
              >
                <p className="contract-helper-text">Date of birth:</p>
                <p>{dateOfBirthFormatted}</p>
              </td>
            </tr>
            <tr>
              <td colSpan="2" className="contract-td contract-half-space">
                <p className="contract-helper-text">{labels.postal_adress}</p>
                <p>{customerAddress}</p>
              </td>
              <td
                colSpan="2"
                className="contract-td contract-half-space contract-border-thick"
              >
                <p className="contract-helper-text">Email</p>
                <p>{customerEmail}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  generateProductRow = (key, objektNr) => {
    if (this.lang === "uk") {
      return this.generateUKProductRow(key, objektNr);
    }

    const { labels, params, productsValues, formInformation } = this.props;
    const product = this.splitPNCNumAndName(productsValues[key].name || "");

    return (
      <>
        <tr className="contract-agreement-table-header">
          <th colSpan="4" className="contract-small-margin-top">
            {this.lang === "fr"
              ? `${labels.product.toUpperCase()} N° ` + objektNr
              : `${labels.product.toUpperCase()} #` + objektNr}
          </th>
        </tr>
        <tr>
          <td className="contract-td contract-min-space">
            <p className="contract-helper-text">{labels.object_type}</p>
            <p>{product.id}</p>
          </td>
          <td className="contract-td contract-second-space">
            <p className="contract-helper-text">
              {this.lang === "fr" ? "Nom de materiel" : "Produkttyp"}
            </p>
            <p>{truncateText(product.name, 50)}</p>
          </td>
          <td className="contract-td">
            <p className="contract-helper-text">{labels.serial_numbers}</p>
            <p>
              {productsValues[key].serial.length > 0
                ? productsValues[key].serial[0]
                : ""}
            </p>
          </td>
          <td className="contract-td">
            <p className="contract-helper-text">{labels.location_type}</p>
            {this.longTermSection()}
          </td>
        </tr>
        <tr>
          <td className="contract-td" colSpan="2">
            <p className="contract-helper-text">
              {labels.original_amount_excl_tax}
            </p>
            <p>
              {formatNumber(
                productsValues[key].purchasePrice +
                  productsValues[key].installation,
                this.lang,
              )}
            </p>
          </td>
          <td className="contract-td">
            <p className="contract-helper-text">
              {labels.residual_value + " " + labels.residual_value_suffix}
            </p>
            <p>{formatNumber(productsValues[key].residualPrice, this.lang)}</p>
          </td>
          <td className="contract-td">
            <p className="contract-helper-text">{labels.number_of_months}</p>
            <p>{formInformation.contractLength}</p>
          </td>
        </tr>
      </>
    );
  };

  generateAccessories = (key, accessoryId, objektNr) => {
    const { labels, params, productsValues, formInformation } = this.props;
    const accessory = this.splitPNCNumAndName(
      productsValues[key].accessory[accessoryId] || "",
    );

    return (
      <>
        <tr className="contract-agreement-table-header">
          <th colSpan="4" className="contract-small-margin-top">
            {this.lang === "fr"
              ? "ACCESSOIRES #" + objektNr
              : "Accessories #" + objektNr}
          </th>
        </tr>
        <tr>
          <td className="contract-td contract-min-space">
            <p className="contract-helper-text">{labels.object_type}</p>
            <p>{accessory.id}</p>
          </td>
          <td className="contract-td contract-second-space">
            <p className="contract-helper-text">
              {this.lang === "fr" ? "Nom de materiel" : "Produkttyp"}
            </p>
            <p>{truncateText(accessory.name, 60)}</p>
          </td>
          <td className="contract-td" style={{ width: "35%" }}>
            <p className="contract-helper-text">{labels.serial_numbers}</p>
            <p>
              {productsValues[key].serial.length > 1
                ? productsValues[key].serial[1]
                : emptyLabel}
            </p>
          </td>
          <td className="contract-td">
            <p className="contract-helper-text">{labels.number_of_months}</p>
            <p>{formInformation.contractLength}</p>
          </td>
        </tr>
        <tr>
          <td className="contract-td" colSpan="2">
            <p className="contract-helper-text">
              {labels.original_amount_excl_tax}
            </p>
            <p>
              {formatNumber(
                productsValues[key].purchasePriceAccessory[accessoryId] +
                  productsValues[key].installationAccessory[accessoryId],
                this.lang,
              )}
            </p>
          </td>
          <td className="contract-td" colSpan="2">
            <p className="contract-helper-text">
              {labels.residual_value + " " + labels.residual_value_suffix}
            </p>
            <p>
              {formatNumber(
                productsValues[key].residualPriceAccessory[accessoryId],
                this.lang,
              )}
            </p>
          </td>
        </tr>
        <tr className="contract-agreement-table-header">
          <th colSpan={2} className="contract-half-space">
            <p className="contract-small-margin-top">
              {labels.lessor_obligations}
            </p>
          </th>
          <th colSpan={3} className="contract-small-margin-top">
            <p className="contract-small-margin-top">
              {labels.insurance_responsability}
            </p>
          </th>
        </tr>
        <tr>
          <td colSpan={2} className="contract-td contract-half-space">
            <p className="contract-helper-text">{labels.service}</p>
            <p>{labels.if_applicable}</p>
          </td>
          <td colSpan={3} className="contract-td">
            <p>{labels.lessor}</p>
          </td>
        </tr>
        <tr>
          <td>
            <p></p>
          </td>
        </tr>
      </>
    );
  };

  generateHeaderSection() {
    const { labels, formInformation, customerInformation } = this.props;

    return (
      <div className="contract-header">
        <img
          src={
            config.ROOT + `getimage?company=hcs&country=images&type=Logo.jpg`
          }
          alt=""
          width="12%"
          height="12%"
        />
        <div className={this.lang === "uk" ? "contract-header-uk-content" : ""}>
          <h4 className="contract-agreement-table-header first">
            {labels.contract_transfer_agreement.toUpperCase()}
          </h4>
          <table className="contract-table">
            <tr>
              <td className="contract-td">
                <p>{labels.contract_number}</p>
              </td>
              <td
                className={`contract-td contract-min-width-first-table-${this.lang}`}
              >
                <p>{formInformation.contractNumber}</p>
              </td>
            </tr>
            <tr>
              <td className="contract-td">
                <p>{labels.dealer_ref_nr}</p>
              </td>
              <td
                className={`contract-td contract-min-width-first-table-${this.lang}`}
              >
                <p>
                  {this.lang === "uk"
                    ? customerInformation.customerNumber
                    : customerInformation.customerFirstName +
                      " " +
                      customerInformation.customerLastName}
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    );
  }

  generatePartiesSection() {
    const { labels, customerInformation } = this.props;

    return (
      <div className="contract-parties">
        <table className="contract-table">
          <tr className="contract-agreement-table-header">
            <th colSpan="4">{labels.parties.toUpperCase()}</th>
          </tr>
          <tr>
            <td colSpan="2">
              {this.lang === "uk" ? 'Husqvarna UK Limited ("Owner")' : "HCS"}
            </td>
            <td colSpan="2">{labels.label_dealer}</td>
          </tr>
          <tr>
            <td colSpan="2" className="contract-td contract-half-space">
              <p className="contract-helper-text">
                {labels.label_customer_name}
              </p>
              <p>{labels.hcs_name}</p>
            </td>
            <td
              colSpan="2"
              className="contract-td contract-half-space contract-border-thick"
            >
              <p className="contract-helper-text">
                {this.lang === "fr" || this.lang === "uk"
                  ? labels.label_customer_name
                  : this.lang === "de"
                    ? `${labels.label_customer_name_contract} / ${labels.label_dealer_name}`
                    : ""}
              </p>
              <p>{customerInformation.dealerName}</p>
            </td>
          </tr>
          <tr>
            <td colSpan="2" className="contract-td contract-quater-space">
              <p className="contract-helper-text">{labels.org_number}</p>
              <p>{labels.hcs_org_nr}</p>
            </td>
            <td
              colSpan="2"
              className="contract-td contract-quater-space contract-border-thick"
            >
              <p className="contract-helper-text">{labels.org_number}</p>
              <p>{this.props.customerInformation.companyRegNumber}</p>
            </td>
          </tr>
          {this.lang === "uk" && (
            <tr>
              <td colSpan="2" className="contract-td contract-quater-space">
                <p className="contract-helper-text">
                  {labels.vat_registration}
                </p>
                <p>{labels.vat_registration_no}</p>
              </td>
              <td
                colSpan="2"
                className="contract-td contract-quater-space contract-border-thick"
              >
                <p className="contract-helper-text">
                  {labels.vat_registration}
                </p>
                <p>{emptyLabel}</p>
              </td>
            </tr>
          )}
          <tr>
            <td colSpan="2" className="contract-td contract-quater-space">
              <p className="contract-helper-text">{labels.postal_adress}</p>
              <p>{labels.hcs_adress}</p>
            </td>
            <td
              colSpan="2"
              className="contract-td contract-quater-space contract-border-thick"
            >
              <p className="contract-helper-text">{labels.postal_adress}</p>
              <p>{customerInformation.dealerAdress}</p>
            </td>
          </tr>
          <tr>
            <td colSpan="1" className="contract-td contract-half-quater-space">
              <p className="contract-helper-text">
                {this.lang === "uk" ? labels.post_code : labels.zip_code}
              </p>
              <p>{labels.hcs_zip}</p>
            </td>
            <td
              colSpan="1"
              className={`contract-td contract-third-space-${this.lang}`}
            >
              <p className="contract-helper-text">{labels.label_city}</p>
              <p>{labels.hcs_city}</p>
            </td>
            <td
              colSpan="1"
              className="contract-td contract-border-thick contract-half-quater-space"
            >
              <p className="contract-helper-text">
                {this.lang === "uk" ? labels.post_code : labels.zip_code}
              </p>
              <p>{customerInformation.dealerZipCode}</p>
            </td>
            <td
              colSpan="1"
              className={`contract-td contract-city-right-${this.lang}`}
            >
              <p className="contract-helper-text">{labels.label_city}</p>
              <p>{customerInformation.dealerCity}</p>
            </td>
          </tr>
          <tr>
            <td colSpan="2" className="contract-td contract-half-space">
              <p className="contract-helper-text">
                {this.lang === "fr"
                  ? "Courrier Electronic Husqvarna (questions générales, en français)"
                  : this.lang === "de"
                    ? "E-Mail Husqvarna (allgemeine Fragen, auf Deutsch)"
                    : this.lang === "uk"
                      ? "Email (general questions)"
                      : ""}
              </p>
              <p>
                <strong>{labels.hcs_lease_email}</strong>
              </p>
            </td>
            <td
              colSpan="2"
              className="contract-td contract-quater-space contract-border-thick"
            >
              <p className="contract-helper-text">{labels.contact_person}</p>
              <p>{customerInformation.sellerName}</p>
            </td>
          </tr>
          <tr>
            <td colSpan="2" className="contract-td contract-half-space">
              <p className="contract-helper-text">
                {this.lang === "fr" ? (
                  <>
                    Contact HCS (questions sur les factures/paiements, en
                    anglasis)
                  </>
                ) : this.lang === "de" ? (
                  <>E-Mail HCS (Fragen zu Rechnungen/Zahlungen, auf Englisch)</>
                ) : this.lang === "uk" ? (
                  "Email (Questions regarding invoices and payments)"
                ) : (
                  ""
                )}
              </p>
              <p>
                {this.lang === "fr" || this.lang === "uk"
                  ? labels.hcs_email_support
                  : labels.hcs_email}
              </p>
            </td>
            <td colSpan="2" className="contract-td contract-border-thick">
              <p className="contract-helper-text">
                {labels.label_electronic_email}
              </p>
              <p>{customerInformation.dealerEmail}</p>
            </td>
          </tr>
        </table>
      </div>
    );
  }

  generateProductSection() {
    const { labels, params, productsValues, formInformation } = this.props;
    const firstProductKey = Object.keys(productsValues)[0];

    if (this.lang === "uk") {
      return (
        <>
          <div className="margin-top-min">
            <table className="contract-table">
              <tbody>{this.generateUKProductRow(firstProductKey, null)}</tbody>
            </table>
          </div>
          {this.generateHirerDetails()}
        </>
      );
    }

    const firstProductData = this.splitPNCNumAndName(
      productsValues[firstProductKey].name || "",
    );

    return (
      <div className="margin-top-min">
        <table className="contract-table">
          <tr className="contract-agreement-table-header">
            <th colSpan="4" className="contract-small-margin-top">
              {this.lang === "fr"
                ? labels.product.toUpperCase() +
                  " N° 1 (matériels supplémentaires à indiquer sur les pages suivantes)"
                : labels.product.toUpperCase() + "#1"}
            </th>
          </tr>
          <tr>
            <td className="contract-td contract-min-space">
              <p className="contract-helper-text">{labels.object_type}</p>
              <p>{firstProductData.id}</p>
            </td>
            <td className="contract-td contract-second-space">
              <p className="contract-helper-text">
                {this.lang === "fr" ? "Nom de materiel" : "Produkttyp"}
              </p>
              <p>{truncateText(firstProductData.name, 60)}</p>
            </td>
            <td className="contract-td">
              <p className="contract-helper-text">{labels.serial_numbers}</p>
              <p>
                {productsValues[firstProductKey].serial?.length > 0
                  ? productsValues[firstProductKey].serial[0]
                  : ""}
              </p>
            </td>
            <td className="contract-td">
              <p className="contract-helper-text">{labels.location_type}</p>
              {this.longTermSection()}
            </td>
          </tr>
          <tr>
            <td className="contract-td" colSpan="2">
              <p className="contract-helper-text">
                {labels.original_amount_excl_tax}
              </p>
              <p>
                {formatNumber(
                  productsValues[firstProductKey].purchasePrice +
                    productsValues[firstProductKey].installation,
                  this.lang,
                )}
              </p>
            </td>
            <td className="contract-td">
              <p className="contract-helper-text">
                {labels.residual_value + " " + labels.residual_value_suffix}
              </p>
              <p>
                {formatNumber(
                  productsValues[firstProductKey].residualPrice,
                  this.lang,
                )}
              </p>
            </td>
            <td className="contract-td">
              <p className="contract-helper-text">{labels.number_of_months}</p>
              <p>{formInformation.contractLength}</p>
            </td>
          </tr>
        </table>
      </div>
    );
  }

  generateAgreementSection() {
    const { labels } = this.props;

    return (
      <div className="margin-top-min">
        <table className="contract-table">
          <tbody>
            <tr className="contract-agreement-table-header">
              <th className="contract-small-margin-top">
                {labels.label_contract.toUpperCase()}
              </th>
            </tr>
            <tr>
              <td className="contract-td">
                <p style={{ whiteSpace: "pre-line", textAlign: "justify" }}>
                  {labels.contract_info_transfer_agreement +
                    labels.contract_info_transfer_agreement2 +
                    (this.lang === "de"
                      ? labels.contract_info_transfer_agreement3
                      : "")}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        {this.lang === "de" && (
          <div className="contract-small-margin-top">
            <p
              style={{
                fontSize: "10px",
                whiteSpace: "pre-line",
                textAlign: "justify",
              }}
              dangerouslySetInnerHTML={{
                __html: labels.contract_info_transfer_agreement4,
              }}
            />
          </div>
        )}
      </div>
    );
  }

  generateOtherSection() {
    const { labels } = this.props;

    if (this.lang === "fr") {
      return (
        <>
          <div className="contract-small-margin-top">
            <table className="contract-table">
              <tbody>
                <tr className="contract-agreement-table-header">
                  <th className="contract-small-margin-top">
                    {labels.label_other.toUpperCase()}
                  </th>
                </tr>
                <tr>
                  <td className="contract-td" style={{ height: "70px" }} />
                </tr>
              </tbody>
            </table>
          </div>
          <div className="contract-small-margin-top">
            <p style={{ whiteSpace: "pre-line", textAlign: "justify" }}>
              {labels.appendix_info_transfer_agreement +
                labels.signature_info_transfer_agreement +
                labels.signature_info_transfer_agreement_2}
              <a
                href="hcs-support@husqvarnagroup.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                hcs-support@husqvarnagroup.com.
              </a>
              {labels.signature_info_transfer_agreement_3}
              <a href="hcs-support@husqvarnagroup.com">
                {" "}
                hcs-support@husqvarnagroup.com,
              </a>
              {"ou la CNIL : "}
              <a href="http://www.cnil.fr">http://www.cnil.fr</a>
            </p>
          </div>
        </>
      );
    }

    if (this.lang === "uk") {
      return (
        <>
          <div className="contract-small-margin-top">
            <table className="contract-table">
              <tbody>
                <tr className="contract-agreement-table-header">
                  <th className="contract-small-margin-top">OTHER</th>
                </tr>
                <tr>
                  <td className="contract-td" style={{ height: "70px" }} />
                </tr>
              </tbody>
            </table>
          </div>
          <div className="contract-small-margin-top">
            <p
              style={{
                whiteSpace: "pre-line",
                textAlign: "justify",
                fontSize: "9px",
              }}
            >
              <i>The Owner's General Terms and Conditions for Purchases</i> form
              part of this purchase agreement (the <b>"Agreement"</b>).
              <br />
              By signing and delivering a copy of this Agreement to the Owner:
              (i) the Dealer confirms that it has reviewed and accepts all terms
              of the Agreement, including the General Terms and Conditions for
              Purchases; (ii) the Dealer applies to the Owner to enter into the
              Agreement with the Owner; and (iii) the Dealer agrees to be bound
              by the Agreement upon the Owner's acceptance of the Dealer's
              application. <br /> A binding agreement is constituted when the
              Owner has accepted the Dealer's application. The undersigned
              hereby certifies that it is authorised to represent the Dealer.
            </p>
          </div>
        </>
      );
    }

    return null;
  }

  generateDynamicPages = () => {
    const { productsValues, labels, formInformation, customerInformation } =
      this.props;
    const productKeys = Object.keys(productsValues || {});

    if (productKeys.length === 0) return null;

    const MAX_TABLES_PER_PAGE = this.lang === "uk" ? 8 : 5;
    const pages = [];
    let currentPageTables = [];
    let pageNumber = 2;

    const createPage = (tables, key) => (
      <div key={key} className="page-break">
        <div className="contract-body">
          <div className="contract-header">
            <img
              src={
                config.ROOT +
                `getimage?company=hcs&country=images&type=Logo.jpg`
              }
              alt=""
              width="12%"
              height="12%"
            />
            <div
              className={this.lang === "uk" ? "contract-header-uk-content" : ""}
            >
              <h4 className="contract-agreement-table-header first">
                {labels.contract_transfer_agreement.toUpperCase()}
              </h4>
              <table className="contract-table">
                <tbody>
                  <tr>
                    <td className="contract-td">
                      <p>{labels.contract_number}</p>
                    </td>
                    <td
                      className={`contract-td contract-min-width-first-table-${this.lang}`}
                    >
                      <p>{formInformation.contractNumber}</p>
                    </td>
                  </tr>
                  <tr>
                    <td className="contract-td">
                      <p>{labels.dealer_ref_nr}</p>
                    </td>
                    <td
                      className={`contract-td contract-min-width-first-table-${this.lang}`}
                    >
                      <p>
                        {this.lang === "uk"
                          ? customerInformation.customerNumber
                          : customerInformation.customerFirstName +
                            " " +
                            customerInformation.customerLastName}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="margin-top-large">{tables}</div>
        </div>
      </div>
    );

    const addTableToPage = (table) => {
      if (currentPageTables.length >= MAX_TABLES_PER_PAGE) {
        pages.push(createPage(currentPageTables, `page-${pageNumber}`));
        pageNumber++;
        currentPageTables = [];
      }
      currentPageTables.push(table);
    };

    const firstProductKey = productKeys[0];
    const firstProduct = productsValues[firstProductKey];

    if (firstProduct.accessory) {
      Object.keys(firstProduct.accessory).forEach((accKey, accIndex) => {
        if (firstProduct.accessory[accKey] !== null) {
          addTableToPage(
            <table
              key={`acc-first-${accKey}`}
              className="contract-table"
              style={{ marginBottom: "10px" }}
            >
              <tbody>
                {this.generateAccessories(
                  firstProductKey,
                  accKey,
                  accIndex + 1,
                )}
              </tbody>
            </table>,
          );
        }
      });
    }

    for (let i = 1; i < productKeys.length; i++) {
      const key = productKeys[i];
      const product = productsValues[key];

      addTableToPage(
        <table
          key={`prod-${key}`}
          className="contract-table"
          style={{ marginBottom: "10px" }}
        >
          <tbody>{this.generateProductRow(key, i + 1)}</tbody>
        </table>,
      );

      if (product.accessory) {
        Object.keys(product.accessory).forEach((accKey, accIndex) => {
          if (product.accessory[accKey] !== null) {
            addTableToPage(
              <table
                key={`acc-${key}-${accKey}`}
                className="contract-table"
                style={{ marginBottom: "10px" }}
              >
                <tbody>
                  {this.generateAccessories(key, accKey, accIndex + 1)}
                </tbody>
              </table>,
            );
          }
        });
      }
    }

    if (currentPageTables.length > 0) {
      pages.push(createPage(currentPageTables, `page-${pageNumber}`));
    }

    return pages;
  };

  render() {
    return (
      <div className="wrapper">
        <style>{cssStyles}</style>
        <div id="trasnferAgreementPdf" className="contract-body">
          {this.generateHeaderSection()}
          {this.generatePartiesSection()}
          {this.generateProductSection()}
          {this.generateAgreementSection()}
          {this.generateOtherSection()}
          <div className="page-break" />
          {this.generateDynamicPages()}
        </div>
      </div>
    );
  }
}
